import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  modalHeader: {
    id: 'evC/vg',
    defaultMessage: '{targetName} — Sync Options',
    description: 'Header for the sync config modal',
  },
  closeModal: {
    id: '4BH2f8',
    defaultMessage: 'Close',
    description: 'Close button text',
  },
  saveModal: {
    id: 'RT8KNi',
    defaultMessage: 'Save',
    description: 'Save button text',
  },
  units: {
    id: 'Gfbe9O',
    defaultMessage: 'Units',
    description: 'Units label',
  },
  minimumQuantityInfo: {
    id: '/QE2ty',
    defaultMessage:
      'The minimum quantity is the lowest count that we will reflect in your selling channels regardless of how low your stock counts are. <b>This setting overrides any other settings below.</b>',
    description: 'Info about minimum quantity',
  },
  maximumQuantityInfo: {
    id: 'wf35hB',
    defaultMessage:
      'The maximum quantity is the highest count that we will reflect in your selling channels regardless of how high your stock counts are.',
    description: 'Info about maximum quantity',
  },
  setMaxiumQuantity: {
    id: 'R7/SLB',
    defaultMessage: 'Set Maximum Quantity',
    description: 'Set maximum quantity label',
  },
  setMinimumQuantity: {
    id: 'f6CBak',
    defaultMessage: 'Set Minimum Quantity',
    description: 'Set minimum quantity label',
  },
  maxQuantityMustBeGreaterThanMinimumQuantity: {
    id: 'H2uYyW',
    defaultMessage: 'Incompatible quantity range. Ensure the minimum quantity is lower than the maximum.',
    description: 'Max must be greater than min',
  },
  setBufferStockQuantity: {
    id: '0NzeH1',
    defaultMessage: 'Set a Buffer Stock',
    description: 'Set a buffer stock label',
  },
  bufferStockQuantityInfo: {
    id: 'qZiY4+',
    defaultMessage:
      'The quantity that will be deducted from your stock counts before being synced to your targets (ex: you have 100 in stock with a buffer stock of 10, only 90 will be synced).',
    description: 'Info about buffer stock quantity',
  },
  setSyncPercentage: {
    id: 'S8aGce',
    defaultMessage: 'Set a Percentage of Stock',
    description: 'Set sync percentage label',
  },
  syncPercentageInfo: {
    id: 'bkn+X5',
    defaultMessage:
      'The percentage of available stock you want to sync. For example, if you have 100 in stock and a buffer of 10 (leaving 90), and you set this to 50%, only 45 units will be synced.',
    description: 'Info about sync percentage',
  },
  percentage: {
    id: 'IYZuUz',
    defaultMessage: 'Percentage',
    description: 'Percentage label',
  },
  errorPercentageMustBeBetweenZeroAndOneHundred: {
    id: 'EAXQa9',
    defaultMessage: 'Percentage must be between 0 and 100.',
    description: 'Error message when percentage is out of range',
  },
  mapWarehousesSectionHeader: {
    id: 'yA7Gs+',
    defaultMessage: 'Map warehouses',
    description: 'Map warehouses section header',
  },
  mapWarehousesInfo: {
    id: '7/VOCK',
    defaultMessage:
      'You can match your {channel} locations to a warehouse in ShipStation. This means that once you click Save, only inventory counts from that selected warehouse will be synced to such location.',
    description: 'Info about mapping warehouses',
  },
  mapWarehousesToSingleWarehouse: {
    id: 'EivaTL',
    defaultMessage: 'Sync all inventory to a single warehouse.',
    description: 'Map all warehouses to a single warehouse label',
  },
  mapWarehousesSelectWarehouse: {
    id: '7XTTEg',
    defaultMessage: 'Select warehouse',
    description: 'Select warehouse dropdown label',
  },
  mapWarehousesAddWarehousesToChannel: {
    id: '6qvyea',
    defaultMessage: 'Add warehouses to your {channel} to sync inventory to it.',
    description: 'Inform the user that they need to add warehouses to their channel to sync inventory to it.',
  },
  successSavingTitle: {
    id: '3sS1n1',
    defaultMessage: 'Sync options saved.',
    description: 'Saving inventory sync options success title',
  },
  successSavingMessage: {
    id: '1gMHh5',
    defaultMessage: 'Inventory sync options saved.',
    description: 'Saving inventory sync options success message',
  },
  errorSavingTitle: {
    id: 'gkr7lW',
    defaultMessage: 'Failed to save sync options.',
    description: 'Saving inventory sync options error title',
  },
  errorSavingMessage: {
    id: 'b/KBbg',
    defaultMessage: 'An error occurred saving the inventory sync options.',
    description: 'Saving inventory sync options error message',
  },
  errorMaxMustBeGreaterThanMinQty: {
    id: 'iGyAs1',
    defaultMessage: 'Maximum quantity must be greater than minimum quantity.',
    description: 'Message to let the user know that the maximum quantity must be greater than the minimum quantity',
  },
  minMaxNextAffectMessage: {
    id: 'ZHUt60',
    defaultMessage: 'These settings will be applied the next time a SKU count changes.',
    description:
      'Message to let the user know that the minimum and maximum quantity settings will take affect the next time a SKU count changes',
  },
});
